var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-content"
  }, [_c('p', [_vm._v("\n    Fill in the URI of the resource you want to create/edit.\n  ")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#!create"
    }
  }, [_vm._v("Create resource...")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33658cc4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 38
// module chunks = 1